import React, { Component } from 'react'
import injectTapEventPlugin from 'react-tap-event-plugin'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Footer from './Footer/Footer'
import NavBar from '../containers/NavBar'
import '../stylesheets/App.scss'

injectTapEventPlugin();

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#19191A'
  }
});

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
          <div className="App">
            <NavBar />
            <div className="body">
              {this.props.children}
            </div>
            <Footer />
          </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js